import React, { memo, useState, useEffect, useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import { ExpandButton, Tabs } from '@components';
import actions from '@flux/action';
import List from './historyList';
import FullScreenTable from './fullscreenHistoryTable';
import {
  getValueFromSearchParam,
  removeValueFromSearchParam,
  setURLSearchParam,
} from '@utils/history';
import { useHistory } from 'react-router-dom';
import searchParamKeys from '@model/searchParamKeys';

function CompanyHistory({
  data: { hist = [{}, {}] },
  historyData,
  fetchData,
  currentId,
  isSingleCompany = false,
}) {
  const { tab: defaultValue, expand: initialExpand = false } =
    getValueFromSearchParam(searchParamKeys.tab, searchParamKeys.expand);

  const [expand, setExpand] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();
  const onTabChange = useCallback((e, tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);

  const expandCharts = () => {
    setExpand(!expand);
    if (!expand) {
      setURLSearchParam(history, {
        [searchParamKeys.expand]: true,
      });
    } else {
      removeValueFromSearchParam(history, [searchParamKeys.expand]);
    }
  };
  const [buyer = {}, target = {}] = hist;

  const { data: { buyer: buyerData = {}, target: targetData = {} } = {} } =
    historyData;
  const buyerListProps = {
    ...buyerData,
    isLoading,
  };

  useEffect(() => {
    if (!isEmpty(historyData) && initialExpand) {
      setExpand(initialExpand);
    }
  }, [historyData]);

  const targetListProps = {
    ...targetData,
    isLoading,
  };

  useEffect(() => {
    if (expand) {
      document.body.style.overflowY = 'hidden';
    }
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [expand]);

  useEffect(() => {
    if (historyData.hasData || isLoading) {
      return;
    }
    (async () => {
      setIsLoading(true);
      await fetchData(currentId);
      setIsLoading(false);
    })();
  }, [historyData, currentId]);

  const genCompanyTabs = () => {
    const buyerTab = {
      label: buyer.companyName || '-',
      children: expand ? (
        <FullScreenTable {...buyerListProps} />
      ) : (
        <List {...buyerListProps} />
      ),
    };

    if (isSingleCompany) {
      return [buyerTab];
    }
    return [
      buyerTab,
      {
        label: target.companyName || '-',
        children: expand ? (
          <FullScreenTable {...targetListProps} />
        ) : (
          <List {...targetListProps} />
        ),
      },
    ];
  };

  return (
    <div className={`analysis-right-wrapper ${expand && 'full-screen'}`}>
      <div
        className={`title expand-box ${
          expand ? 'full-screen-title no-border' : 'title-no-bottom-border'
        }`}
      >
        <div>Company History</div>
        {!isLoading && (
          <ExpandButton
            onClick={expandCharts}
            initialExpand={initialExpand}
            scrollPageFooter
          />
        )}
      </div>

      <Tabs
        className="company-history-tab-wrapper"
        defaultValue={defaultValue}
        onChange={onTabChange}
        isSingleCompany={isSingleCompany}
        tabs={genCompanyTabs()}
      />
    </div>
  );
}

CompanyHistory.propTypes = {};

const mapStateToProps = ({ common, analysis }) => ({
  currentId: common.currentId,
  historyData: (analysis.companyHistoryData || {})[common.currentId] || {},
});

const mapDispatchToProps = (dispatch) => ({
  fetchData() {
    return dispatch(actions.fetchCompanyHistoryData());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(CompanyHistory));
